/** Structural feature data (locale-free). Copy lives in locales/{locale}/features.json */
export const FEATURE_FOUR_STRUCTURE = [
  { id: 1, icon: "flaticon-life-insurance" },
  { id: 2, icon: "flaticon-handshake" },
  { id: 3, icon: "flaticon-money" },
];

export const getFeaturesFour = (t) =>
  FEATURE_FOUR_STRUCTURE.map((feature) => {
    const copy = t(String(feature.id), { ns: "features", returnObjects: true });
    return {
      ...feature,
      ...(copy && typeof copy === "object" ? copy : {}),
    };
  });

/** @deprecated Prefer getFeaturesFour(t) */
export const FEATURE_FOUR_LIST = FEATURE_FOUR_STRUCTURE;
